import { SimpleChange } from '@angular/core';

import {
  CurveType,
  ForecastMethodType,
  listDriverSiteGroupsQuery,
  listTimelineMilestonesQuery,
} from '@shared/services/gql.service';

import { FullActivity, FullCategory, FullSettings } from '../../../state/category/category.query';
import { ForecastQuery } from '../../../state/forecast/forecast.query';
import { ForecastTableGridComponent } from '../forecast-table-grid.component';

export enum ForecastTableGridCategoryTypes {
  Service,
  Cost,
}

export enum ForecastTableGridTimelineCustomMilestoneDatepickerType {
  END_DATE = 'end-date',
  START_DATE = 'start-date',
}

export interface ForecastTableGridDataInterface {
  activityCheckedCount: number;
  categoryIndex: number;
  categoryName: string;
  costCategoryType: string;
  driver: string;
  driverSettingId: string;
  fullActivity: FullActivity | null;
  fullCategory: FullCategory | null;
  fullParentCategory: FullCategory | null;
  id: string;
  indentLevel: number;
  isChild: boolean;
  isCost: boolean;
  isDisplayed: boolean;
  isOpen: boolean;
  method: string;
  parentCategory: ForecastTableGridDataInterface | null;
  parentId: null | string;
  period: string;
  primarySettingsId: string;
  primarySettingsOverride: boolean;
  remaining: number;
  subCategory: boolean;
  total: number;
  units: string;
  uom: string;
}

export interface ForecastTableGridDriverSelectMode {
  id: string;
  name: 'activity' | 'category';
}

export interface ForecastTableGridExpenses {
  amount: number;
  amountPercent: number;
}

export interface ForecastTableGridFullCategoryExtended extends FullCategory {
  subCategories: ForecastTableGridFullCategoryExtended[];
}

export type ForecastTableGridMethodChange = (
  event: ForecastMethodType | null | string,
  primarySettingsId: string,
  mode: ForecastTableGridMethodSelectMode
) => void;

export interface ForecastTableGridMethodSelectMode {
  id: string;
  name: 'activity' | 'category';
  prop: 'driver_setting' | 'forecast_method';
}

export interface ForecastTableGridNgOnChangesInterface {
  [key: string]: SimpleChange;
}

export interface ForecastTableGridParentComponentContext {
  componentParent: ForecastTableGridComponent;
  forecastQuery: ForecastQuery;
}

export type ForecastTableGridPeriodChange = (
  settings: FullSettings,
  mode: ForecastTableGridDriverSelectMode
) => void;

export type ForecastTableGridSaveChange = () => Promise<void>;

export interface ForecastTableGridSiteCurveInterface {
  curveType: CurveType;
  label: string;
  showLine: boolean;
  value: string;
}

export interface ForecastTableGridSiteCurveResultsInterface {
  data: listDriverSiteGroupsQuery[] | null;
  errors: string[];
  success: boolean;
}

export interface ForecastTableGridTimelineCategoriesInterface {
  [key: string]: ForecastTableGridTimelineCategoriesValueInterface;
}

export interface ForecastTableGridTimelineCategoriesValueInterface {
  milestones: ForecastTableGridTimelineMilestoneInterface[];
  name: string;
}

export interface ForecastTableGridTimelineItemsResultsInterface {
  data: listTimelineMilestonesQuery[] | null;
  errors: string[];
  success: boolean;
}

export interface ForecastTableGridTimelineMilestoneInterface {
  end_date: string;
  id: string;
  name: string;
  start_date: string;
}

export interface ForecastTableGridTimelinePhaseInterface {
  cat_id: string;
  firstMilestone: ForecastTableGridTimelineMilestoneInterface | null;
  lastMilestone: ForecastTableGridTimelineMilestoneInterface | null;
  milestones: ForecastTableGridTimelineMilestoneInterface[];
  name: string;
}

export interface ForecastTableGridToggleInterface {
  [key: string]: boolean;
}

export interface ForecastTableTimelineOverlayData {
  settings: FullSettings;
  timelineMilestones: ForecastTableGridTimelineMilestoneInterface[];
  timelinePhases: ForecastTableGridTimelinePhaseInterface[];
}

export interface ForecastTableTimelineOverlayResponse {
  endDate: null | string;
  endMilestoneId: null | string;
  phaseId: null | string;
  startDate: null | string;
  startMilestoneId: null | string;
}
